import classNames from "classnames";

import statisticsCSS from "src/app/modules/admin/components/statistics/Statistics.module.css";

const StatisticsListPlus = ({
  inputData,
  shouldNavigateToAdminProjects,
  navigateToAdminProjects,
}: {
  inputData: Array<any>;
  shouldNavigateToAdminProjects: boolean;
  navigateToAdminProjects: (id: number) => void;
}) => {
  return (
    <div className={statisticsCSS.listWrap}>
      <table className={statisticsCSS.listTable}>
        <tr className={statisticsCSS.queriesTotal}>
          <td>
            <span>Ukupno:</span>
          </td>
          <td>
            <span>-</span>&nbsp;
            {inputData ? inputData.reduce((s, { projectsCount }) => s + projectsCount, 0) : 0}&nbsp;
            <span>upita</span>
          </td>
        </tr>
      </table>
      {inputData && (
        <div className={statisticsCSS.tablesContainer}>
          <table className={statisticsCSS.listTable}>
            <tr className={statisticsCSS.totalBorder}>
              <td></td>
            </tr>
          </table>
          {inputData?.map((element: any, index: number) => {
            return (
              <>
                <table className={statisticsCSS.listTable}>
                  <tr
                    className={shouldNavigateToAdminProjects ? "u-cursor-pointer" : ""}
                    onClick={() => {
                      navigateToAdminProjects(inputData[index].id);
                    }}
                  >
                    <td>{`#${index + 1}`}</td>
                    <td>{element.name}</td>
                    <td>
                      <span>-</span>&nbsp;
                      {element.projectsCount}&nbsp;
                      <span>upita</span>
                    </td>
                  </tr>
                </table>
                <div className={classNames("u-flex", "u-pl40px", "u-flex-items-center", statisticsCSS.itemDetails)}>
                  {element.children &&
                    element.children.map((region: any, regionIndex: number) => {
                      return (
                        <div className={classNames("u-flex", "u-mb15px", statisticsCSS.detailsWrap)}>
                          <div>{region.name}</div>&nbsp;
                          <div>
                            {region.projectsCount}&nbsp;
                            <span>upita</span>
                          </div>
                          &nbsp;
                          <div>
                            {`(${region.projectsStake}%)`}&nbsp;{element.children.length > regionIndex + 1 ? <>&#8226;</> : <></>}&nbsp;
                          </div>
                        </div>
                      );
                    })}
                </div>
              </>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StatisticsListPlus;
